<template>
	<v-container grid-list-md class="pt-4 pb-0" id="explorer">

		<v-layout row wrap>
			<Docs></Docs>

			<v-flex shrink>
				<v-autocomplete
					dense
					clearable
					hide-details
					:disabled="loading"
					class="mt-0 pt-0 grv-input pdms-input"
					:menu-props="{
						closeOnContentClick: true,
						contentClass: 'grv-menu'
					}"
					:items="ordered_shortcuts"
					v-model="selected_shortcut"
					ref="pdm_shortcut_input"
					label="Points de montage">
					<template slot="item" slot-scope="data">
						<v-list-tile @click="onShortcutChange(data.item.value)">
							<v-list-tile-content>
								<v-list-tile-title>
									{{ data.item.unc_path }}
								</v-list-tile-title>
							</v-list-tile-content>
							<v-list-tile-action>
								<v-btn
									v-if="user_favorites.indexOf(data.item.value) > -1"
									small flat icon
									color="cyan accent-4"
									@click.stop="removeUserFavorite(data.item.value)">
									<v-icon>star</v-icon>
								</v-btn>
								<v-btn
									v-else
									small flat icon
									color="background lighten-2"
									@click.stop="addUserFavorite(data.item.value);
												onShortcutChange(data.item.value);
												$refs.pdm_shortcut_input.blur()">
									<v-icon>star_outline</v-icon>
								</v-btn>
							</v-list-tile-action>
						</v-list-tile>
					</template>
				</v-autocomplete>
			</v-flex>

			<v-flex grow>
				<v-combobox
					dense
					hide-details
					:disabled="loading"
					class="my-0 pt-0 grv-input path-input"
					:value="current_path_display"
					item-value="value"
					item-text="display"
					:menu-props="{
						closeOnContentClick: true,
						contentClass: 'grv-menu'
					}"
					@change="onCurrentPathChange($event)"
					:items="registered_paths"
					label="Chemin">
					<template slot="prepend-inner">
						<v-btn
							flat icon
							class="ma-0"
							id="nav-back-btn"
							:disabled="preventBack"
							@click.stop="navigateBack()"
							title="[Ctrl + flèche gauche]">
							<v-icon large>chevron_left</v-icon>
						</v-btn>
					</template>
					<template slot="item" slot-scope="data">
						<v-list-tile @click="onCurrentPathChange(data.item.value)">
							<v-list-tile-avatar style="min-width: 46px">
								<v-icon
									v-if="data.item.type === 'favorite'"
									color="cyan accent-4">
									star
								</v-icon>
								<v-icon
									v-else-if="data.item.type === 'history'"
									color="white">
									history
								</v-icon>
							</v-list-tile-avatar>
							<v-list-tile-content>
								<v-list-tile-title>
									{{ data.item.display }}
								</v-list-tile-title>
							</v-list-tile-content>
							<v-list-tile-action v-if="data.item.type === 'favorite'">
								<v-btn
									small flat icon
									color="warning"
									@click="removeUserFavorite(data.item.value)">
									<v-icon>delete_forever</v-icon>
								</v-btn>
							</v-list-tile-action>
						</v-list-tile>
					</template>
				</v-combobox>
			</v-flex>
		</v-layout>

		<v-layout
			row align-center
			class="pl-1 ma-0 path-breadcrumb">
			<v-btn
				v-if="user_favorites.indexOf(current_path) > -1"
				flat icon
				class="ma-0"
				color="cyan accent-4"
				@click.stop="removeUserFavorite(current_path)">
				<v-icon>star</v-icon>
			</v-btn>
			<v-btn
				v-else
				flat icon
				class="ma-0"
				color="background lighten-2"
				@click.stop="addUserFavorite(current_path)">
				<v-icon>star_outline</v-icon>
			</v-btn>
			<span id="path_steps" v-if="path_steps">
				<v-btn
					color="background"
					@click.prevent="navigateStep(1)"
					class="path-btn text-none">
					{{ path_steps.root[0] }}
					<span>/</span>
					{{ path_steps.root[1] }}
				</v-btn>
				<span
					v-for="(step, index) in path_steps.steps"
					:key="'step' + index"
					class="mr-1">
					<span>/</span>
					<v-btn
						color="background"
						@click.prevent="navigateStep(index + 2)"
						class="path-btn text-none">
						{{ step }}
						<v-icon
							v-if="index === path_steps.steps.length - 1"
							size="20"
							class="ml-1">
							refresh
						</v-icon>
					</v-btn>
				</span>
			</span>
		</v-layout>

		<span id="explorer-table-top"></span>
		<div
			id="explorer-table"
			ref="explorer-table">
		</div>

		<v-layout
			row align-center
			class="px-2 ma-0 table-footer">

			<v-text-field
				clearable
				hide-details
				:disabled="loading"
				persistent-hint
				class="mt-0 pt-0 grv-input-dense search-input"
				v-model="search"
				placeholder="Filtrer"
				prepend-inner-icon="filter_list"
				ref="search_input"
				@input="onSearch($event)"
				@click:clear="onSearch(null)">
			</v-text-field>

			<!-- <span shrink v-if="$user.isAdmin">
				<v-tooltip top color="background darken-1">
					<template v-slot:activator="{ on }">
						<v-switch
							v-on="on"
							hide-details
							class="mt-0 ml-3 mb-1"
							label="fichiers cachés"
							@change="onCurrentPathChange(current_path, true)"
							color="primary"
							v-model="show_hidden">
						</v-switch>
					</template>
					<span v-if="show_hidden">
						Ne pas lister les fichiers cachés
					</span>
					<span v-else>Lister les fichiers cachés</span>
				</v-tooltip>
			</span> -->

			<v-spacer></v-spacer>

			<div v-if="launcher_enabled && items.length">
				<div xs3 class="text-right">
					<v-menu offset-y top :close-on-content-click="false">
						<template v-slot:activator="{ on }">
							<v-btn
								:disabled="selected.length === 0"
								color="primary color--text"
								class="text-none ma-0"
								flat
								v-on="on">
								<span v-if="selected.length <= 1">
									{{ selected.length }} Asset Sélectionné
								</span>
								<span v-else>
									{{ selected.length }} Asset(s) Sélectionné(s)
								</span>
							</v-btn>
							<v-btn
								:disabled="selected.length === 0"
								color="primary color--text"
								class="text-none ma-0 ml-1"
								flat
								@click="directDDL(selected)">
								<v-icon class="mr-2">send</v-icon>
								Envoyer en DDL
							</v-btn>
						</template>
						<v-list dense class="background darken-1">
							<v-list-tile
								v-for="(item, i) in selected"
								:key="'selected' + i"
								@click="table.deselectRow(selected_rows[i])">
								<v-list-tile-avatar>
									<v-icon color="primary">check_box</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-content>
									<v-list-tile-title>
										{{ item.name }}
									</v-list-tile-title>
									<v-list-tile-sub-title class="text-left">
										{{ item.size | humanizeBytes1000 }}
									</v-list-tile-sub-title>
								</v-list-tile-content>
							</v-list-tile>
						</v-list>
					</v-menu>
				</div>
			</div>
			<div v-if="!launcher_enabled && items.length">
				<div xs3 v-if="multiselect" class="text-right">
					<v-menu offset-y top :close-on-content-click="false">
						<template v-slot:activator="{ on }">
							<v-btn
								:disabled="selected.length === 0"
								color="primary color--text"
								class="text-none ma-0"
								flat
								v-on="on">
								<span v-if="selected.length <= 1">
									{{ selected.length }} Asset Sélectionné
								</span>
								<span v-else>
									{{ selected.length }} Asset(s) Sélectionné(s)
								</span>
							</v-btn>
							<v-btn
								:disabled="selected.length === 0"
								color="primary color--text"
								class="text-none ma-0 ml-1"
								flat
								@click="emitSelected(selected)">
								<v-icon large>arrow_forward</v-icon>
							</v-btn>
						</template>
						<v-list dense class="background darken-1">
							<v-list-tile
								v-for="(item, i) in selected"
								:key="'selected' + i"
								@click="table.deselectRow(selected_rows[i])">
								<v-list-tile-avatar>
									<v-icon color="primary">check_box</v-icon>
								</v-list-tile-avatar>
								<v-list-tile-title>
									{{ item.path }}
								</v-list-tile-title>
							</v-list-tile>
						</v-list>
					</v-menu>
				</div>
				<div xs2 v-else class="text-right">
					<v-btn
						:disabled="selected.length === 0"
						color="primary color--text"
						class="text-none ma-0"
						flat
						@click="emitSelected(selected)">
						<span v-if="selected[0]">
							{{ selected[0].name }}
						</span>
						<v-icon large right>arrow_forward</v-icon>
					</v-btn>
				</div>
			</div>
		</v-layout>

		<v-dialog
			v-model="modal_probe.visible"
			scrollable
			max-width="800px"
			transition="dialog-transition">
			<v-card class="background">
				<v-card-title
					class="py-1 px-3 primary color--text subheading word-break-all">
					{{ modal_probe.title }}
					<v-spacer></v-spacer>
					<v-btn
						flat icon
						color="color"
						class="my-0"
						@click="openFile('show', modal_probe.title)">
						<v-icon>folder</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-0" v-if="modal_probe.visible">
					<v-progress-linear
						v-if="modal_probe.loading"
						color="primary"
						indeterminate>
					</v-progress-linear>
					<ProbeDisplay
						v-if="!modal_probe.loading && !modal_probe.error"
						:probe="modal_probe.data">
					</ProbeDisplay>
					<v-alert
						type="error"
						class="pa-2 ma-0"
						:value="modal_probe.error !== ''">
						{{ modal_probe.error }}
					</v-alert>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog
			v-model="mkdir_dialog.show"
			scrollable
			width="800px"
			transition="dialog-transition">
			<v-card class="background">
				<v-card-title class="py-1 px-2 subheading background darken-1">
					Créer un nouveau dossier
					<v-spacer></v-spacer>
					<v-btn
						flat icon
						class="ma-0"
						@click="mkdir_dialog.dest_path = null;
										mkdir_dialog.dest_path_label = null;
										mkdir_dialog.show = false;
										mkdir_dialog.error = null;
										mkdir_dialog.loading = false;
										mkdir_dialog.dest_name = '_Nouveau_dossier'">
						<v-icon>close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text class="pa-2">
					<v-text-field
						:prefix="mkdir_dialog.dest_path_label"
						class="grv-input"
						v-model="mkdir_dialog.dest_name">
					</v-text-field>
					<div class="error--text" v-if="mkdir_dialog.error">
						{{ mkdir_dialog.error }}
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						color="primary color--text"
						:disabled="!mkdir_dialog.dest_name"
						@click="mkdir(mkdir_dialog.dest_path, mkdir_dialog.dest_name)">
						OK
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<FileReader :file_path="file_to_read" @close="file_to_read = null">
		</FileReader>

		<HtmlReader :html_path="html_to_read" @close="html_to_read = null">
		</HtmlReader>

		<Loader :loading="loading">
		</Loader>

		<Uploader
			:current_path="current_path"
			:error_nav="error_nav"
			@refresh="onCurrentPathChange(current_path)">
		</Uploader>

		<DirectoryListCsvExport
			:root_path="list_dir_dialog.root_path"
			:deep="list_dir_dialog.deep"
			@close="list_dir_dialog.root_path = ''">
		</DirectoryListCsvExport>

		<v-menu
			v-model="context_menu.show"
			:position-x="context_menu.x"
			:position-y="context_menu.y"
			absolute
			offset-y>
			<v-list dense class="background darken-1 pa-0">
				<v-subheader class="primary color--text">
					<v-icon class="mr-2" color="color">
						{{ context_menu.title.icon }}
					</v-icon>
					{{ context_menu.title.text }}
				</v-subheader>
				<v-list-tile
					v-for="(item, index) in context_menu.items"
					:key="index"
					@click="item.action"
					:class="item.label.color">
					<v-list-tile-avatar>
						<v-icon :color="item.label.color_icon">
							{{ item.label.icon }}
						</v-icon>
					</v-list-tile-avatar>
					<v-list-tile-content v-if="item.label.loading">
						<v-progress-linear
							:indeterminate="true"
							class="ma-0"
							:height="1"
							:color="item.label.color_icon">
						</v-progress-linear>
					</v-list-tile-content>
					<v-list-tile-content v-else>
						<v-list-tile-title>
							{{ item.label.text }}
						</v-list-tile-title>
					</v-list-tile-content>
				</v-list-tile>
			</v-list>
		</v-menu>

	</v-container>
</template>

<script>

import ProbeDisplay from '@/components/ffprobe_display_nexus.vue'
import Docs from '@/pages/filesystem/explorer_documentation.vue'
import Uploader from '@/pages/filesystem/explorer_uploader.vue'
import Loader from '@/components/loader.vue'
import formatters from '@/pages/filesystem/explorer_tabulator_formatters.js'
import Tabulator from 'tabulator-tables'
import { debounce } from 'debounce'
import 'tabulator-tables/dist/css/tabulator_midnight.min.css'
import FileReader from '@/components/file_reader_modal.vue'
import HtmlReader from '@/components/html_reader_modal.vue'
import { isUploaderEnabled } from '@/pages/filesystem/explorer_uploader.js'
import DirectoryListCsvExport from '@/components/directory_list_csv_export.vue'
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'
export default {
	props: [
		'shortcuts',
		'assetType',
		'multiselect',
		'default_folder',
		'return_dir_filelist',
		'no_previous_path',
		'launcher_enabled'
	],
	components: {
		ProbeDisplay,
		Loader,
		FileReader,
		HtmlReader,
		Docs,
		Uploader,
		DirectoryListCsvExport,
		Viewer
	},
	data () {
		return {
			selected_shortcut: null,
			current_path: null,
			search: null,
			show_hidden: false,
			items: [],
			loading: false,
			error_nav: null,
			pdm_list: [],
			explorer_table: null,
			modal_probe: {
				title: '',
				error: '',
				data: {},
				visible: false,
				loading: false
			},
			prevent_store_path: false,
			file_to_read: null,
			html_to_read: null,
			table: null,
			selected: [],
			selected_rows: [],
			user_favorites: [],
			user_history: [],
			context_menu: {
				title: {
					text: null,
					icon: null
				},
				x: 0,
				y: 0,
				items: [],
				show: false
			},
			mkdir_dialog: {
				dest_path: null,
				dest_path_label: null,
				dest_name: '_Nouveau_dossier',
				show: false,
				error: null,
				loading: false
			},
			list_dir_dialog: {
				root_path: '',
				deep: false
			},
			image_extensions: ['bmp', 'gif', 'jpg', 'jpeg', 'png'],
			direct_ddl_max_size: 30e+9
		}
	},
	computed: {
		ordered_shortcuts () {
			let shortcutsFavs = this.shortcuts_list
				.filter(item => {
					return this.user_favorites.indexOf(item.value) > -1
				})
				.sort((a, b) => {
					if (a.text < b.text) return -1
					if (a.text > b.text) return 1
					return 0
				})
			let shortcutsNoFavs = this.shortcuts_list
				.filter(item => {
					return this.user_favorites.indexOf(item.value) === -1
				})
				.sort((a, b) => {
					if (a.text < b.text) return -1
					if (a.text > b.text) return 1
					return 0
				})
			return shortcutsFavs.concat(shortcutsNoFavs)
		},
		preventBack () {
			if (!this.current_path) return true
			// Format Maestro: /media/DATA/server_share minimum = 3 segments
			return this.current_path.split('/').filter(x => x).length <= 3
		},
		registered_paths () {
			let value = []
			this.user_favorites.map(item => {
				value.push({
					value: item,
					display: this.$paths.maestroToUNC(item),
					type: 'favorite'
				})
			})
			this.user_history.map(item => {
				value.push({
					value: item,
					display: this.$paths.maestroToUNC(item),
					type: 'history'
				})
			})
			return value
		},
		path_steps () {
			if (!this.current_path) return null
			// Format Maestro: /media/DATA/server_share/folder1/folder2
			let steps = this.current_path.split('/').filter(step => step)
			// steps = ['media', 'DATA', 'server_share', 'folder1', 'folder2']
			if (steps.length < 3) return null
			// root = server_share converti pour affichage UNC (server / share)
			let serverShare = steps[2]
			let underscoreIndex = serverShare.indexOf('_')
			let root = underscoreIndex > -1
				? [serverShare.substring(0, underscoreIndex), serverShare.substring(underscoreIndex + 1)]
				: [serverShare, '']
			let pathSteps = steps.slice(3)
			return {
				steps: pathSteps,
				root: root
			}
		},
		shortcuts_list () {
			return this.shortcuts || this.pdm_list
		},
		// Affichage UNC du chemin courant pour l'utilisateur
		current_path_display () {
			if (!this.current_path) return null
			return this.$paths.maestroToUNC(this.current_path)
		}
	},
	watch: {
		$route (route) {
			if (route.name === 'Filesystem' &&
				this.$route.query.path &&
				this.$route.query.path !== this.current_path_display) {
				this.onCurrentPathChange(this.$route.query.path, true)
			}
		}
	},
	methods: {
		openFile (mode, path) {
			// FileOpener Windows nécessite un chemin UNC
			let uncPath = this.$paths.maestroToUNC(path)
			this.$FileOpener.fileOpener(mode, uncPath)
				.catch(error => {
					console.error('openWorkingDir error', error)
				})
		},
		probeFile (filepath) {
			this.modal_probe.title = filepath
			this.modal_probe.error = ''
			this.modal_probe.data = {}
			this.modal_probe.visible = true
			this.modal_probe.loading = true
			this.$ApiNexus.ffprobe(filepath)
				.then(result => {
					console.log('probeFile result', result)
					this.modal_probe.loading = false
					this.modal_probe.data = result.data.detail
				})
				.catch(error => {
					console.error('probeFile error', error.response)
					this.modal_probe.loading = false
					this.modal_probe.error = error.response.data
				})
		},
		mkdir (dest_path, dest_name) {
			this.$ApiNexus.mkdir(dest_path + dest_name)
				.then(() => {
					this.mkdir_dialog.dest_path = null
					this.mkdir_dialog.dest_path_label = null
					this.mkdir_dialog.dest_name = '_Nouveau_dossier'
					this.mkdir_dialog.show = false
					this.mkdir_dialog.error = null
					this.mkdir_dialog.loading = false
					this.$Toaster({
						title: `Dossier Créé`,
						content: dest_path + dest_name,
						type: 'success',
						loading: false,
						timeout: 2000
					})
					this.onCurrentPathChange(this.current_path)
				})
				.catch(error => {
					this.mkdir_dialog.error = error.response.data
				})
		},
		copyPath (path) {
			// Le path est en format Maestro, on affiche en UNC pour l'utilisateur
			let displayPath = this.$paths.maestroToUNC(path)
			if (this.$OS === 'Windows') {
				displayPath = displayPath.replace(/\//g, '\\')
			}
			this.$clipboard(displayPath)
			this.$Toaster({
				title: `Chemin copié dans le presse papier`,
				content: displayPath,
				type: 'success',
				loading: false,
				timeout: 2000
			})
		},
		updateShortcut (path) {
			if (path) {
				for (let i = 0; i < this.shortcuts_list.length; i++) {
					let shortcutPath = this.shortcuts_list[i].value.toLowerCase()
					if (path.toLowerCase().indexOf(shortcutPath) > -1) {
						this.selected_shortcut = this.shortcuts_list[i].value
						return
					}
				}
			}
			this.selected_shortcut = null
		},
		updateUrl (path) {
			if (this.$route.name !== 'Filesystem') return
			// Convertir en UNC pour l'URL
			let uncPath = path ? this.$paths.maestroToUNC(path) : null
			if (this.$route.query.path === uncPath) return
			let route = { path: this.$route.path, name: this.$route.name }
			if (uncPath) route.query = { path: uncPath }
			this.$router.push(route)
				.catch(error => {
					console.error(error.message)
				})
		},
		onShortcutChange (shortcut) {
			this.error = null
			this.current_path = shortcut
			if (shortcut) {
				this.onCurrentPathChange(shortcut)
			} else {
				this.items = []
				if (this.table) this.table.setData([])
			}
		},
		onCurrentPathChange (path, fromBackAction) {
			if (path) {
				path = path.replace(/\\/g, '/')
				// Normaliser en Maestro (accepte UNC ou Maestro en entrée)
				path = this.$paths.UNCToMaestro(path)
			}
			this.current_path = path
			if (!fromBackAction) {
				this.updateShortcut(path)
				this.updateUrl(path)
			}
			this.error_nav = ''
			if (this.table) {
				this.table.options.placeholder.innerHTML = '<span> --vide-- </span>'
			}
			// this.search = null
			if (this.loading) return
			if (!path) {
				this.items = []
				if (this.table) this.table.setData([])
				return
			}
			this.getDirContent(path)
				.then(items => {
					this.items = items
					if (this.table) this.table.setData(items)
					if (this.search) {
						this.onSearch(this.search)
						setTimeout(() => {
							this.$refs.search_input.focus()
						}, 100)
					}
				})
				.catch(error => {
					this.items = []
					if (this.table) this.table.setData([])
					let status = ''
					let message = ''
					if (error.response) {
						status = error.response.status
						message = error.response.data.error
					} else {
						status = error.message
						message = 'La connexion au serveur a échoué'
					}
					if (status === 404 && message.indexOf('Not a directory:') > -1) {
						let index = path.lastIndexOf('/')
						let dirPath = path.substring(0, index)
						let fileName = path.substring(index + 1, path.length)
						this.search = fileName
						this.updateUrl(dirPath)
					} else {
						this.error_nav = `${status} - ${message}`
						if (this.table) {
							this.table.options.placeholder.innerHTML = `
								<span class="text-center error--text">
									<i style="font-size: 62px" class="v-icon material-icons">error</i>
									<br>
									${this.$sanitize(status + ' - ' + message)}
								</span>
							`
						}
					}
				})
				.finally(() => {
					this.$nextTick(() => {
						this.updateMultiSelectorHtml()
					})
				})
		},
		navigateBack () {
			let path = this.current_path
			if (!path) return
			// Format Maestro: /media/DATA/server_share minimum = 3 segments
			if (path.split('/').filter(x => x).length <= 3) return
			if (path.slice(-1) === '/') path = path.slice(0, -1)
			path = path.slice(0, path.lastIndexOf('/'))
			this.onCurrentPathChange(path)
		},
		navigateRoot () {
			let path = this.current_path
			if (!path) return
			let parts = path.split('/').filter(item => item)
			if (parts.length <= 3) return
			// Garder /media/DATA/server_share
			path = '/' + parts.slice(0, 3).join('/')
			this.onCurrentPathChange(path)
		},
		navigateStep (stepIndex) {
			// stepIndex 1 = root (server_share), 2+ = sous-dossiers
			let steps = this.current_path.split('/').filter(step => step)
			// steps[0]=media, steps[1]=DATA, steps[2]=server_share
			let sliceEnd = 2 + stepIndex // media/DATA + stepIndex segments
			let newSteps = steps.slice(0, sliceEnd)
			let path = '/' + newSteps.join('/')
			this.onCurrentPathChange(path)
		},
		onSearch: debounce(function (search) {
			if (!search) {
				if (this.table) this.table.setData(this.items)
			} else {
				let items = this.getFilteredRecursive(this.items, search.toLowerCase())
				if (this.table) this.table.setData(items)
			}
			let rows = this.table.getRows()
			this.setAllChildLoadedRowsExpandedRecusive(rows)
			this.updateMultiSelectorHtml()
		}, 200),
		getDirContent (path) {
			return new Promise((resolve, reject) => {
				this.error = null
				this.loading = true
				if (path.slice(-1) === '/') path = path.slice(0, -1)
				// path est déjà en format Maestro
				this.$ApiNexus.ls(path)
					.then(response => {
						let items = response.data
						items.map(item => {
							if (item.type === 'folder') item._children = []
							if (this.assetType) {
								item.isSelectable = item.type === this.assetType
							} else {
								item.isSelectable = true
							}
							if (this.launcher_enabled && item.isSelectable) {
								item.isSelectable = item.size <= 30e+9
							}
						})
						resolve(items)
					})
					.catch(error => {
						reject(error)
					})
					.finally(() => {
						this.loading = false
					})
			})
		},
		getUserFavorites () {
			try {
				let favorites = window.localStorage.getItem('fs_favorites')
				if (favorites) this.user_favorites = JSON.parse(favorites)
			} catch (error) {
				console.error(error)
			}
		},
		addUserFavorite (path) {
			let data = window.localStorage.getItem('fs_favorites')
			if (!data) {
				data = []
			} else {
				data = JSON.parse(data)
				data = data.filter(item => {
					return item !== path
				})
			}
			try {
				data.push(path)
				window.localStorage.setItem('fs_favorites', JSON.stringify(data))
				this.user_favorites = data
			} catch (error) {
				console.error(error)
			}
		},
		removeUserFavorite (path) {
			let data = window.localStorage.getItem('fs_favorites')
			if (data) {
				try {
					data = JSON.parse(data)
					data = data.filter(item => { return item !== path })
					window.localStorage.setItem('fs_favorites', JSON.stringify(data))
					this.user_favorites = data
				} catch (error) {
					return []
				}
			} else {
				return []
			}
		},
		getUserHistory () {
			try {
				let histories = window.localStorage.getItem('fs_history')
				if (histories) this.user_history = JSON.parse(histories)
			} catch (error) {
				console.error(error)
			}
		},
		addUserHistory (path) {
			let data = window.localStorage.getItem('fs_history')
			if (!data) {
				data = []
			} else {
				data = JSON.parse(data)
				data = data.filter(item => {
					return item !== path
				})
			}
			try {
				if (data.length === 10) data.shift()
				data.push(path)
				window.localStorage.setItem('fs_history', JSON.stringify(data))
				this.user_history = data
			} catch (error) {
				console.error(error)
			}
		},
		onDataTreeRowExpanded (row) {
			let rowData = row.getData()
			if (rowData._children.length > 0) return
			if (this.loading) return
			this.getDirContent(rowData.path)
				.then(children => {
					if (children.length === 0) {
						rowData._children = [{
							ext: '',
							isSelectable: false,
							name: '--vide--',
							path: rowData.path,
							type: 'empty'
						}]
					} else {
						rowData._children = children
					}
				})
				.catch(error => {
					let message = this.$commons.deepGet(
						error,
						'response.data',
						'Erreur inconnue'
					)
					rowData._children = [{
						ext: '',
						isSelectable: false,
						name: message,
						path: '',
						type: 'error'
					}]
					this.$Toaster({
						title: `Erreur`,
						content: message,
						type: 'error',
						loading: false,
						timeout: 0
					})
				})
				.finally(() => {
					this.updateMultiSelectorHtml()
				})
		},
		onDataTreeRowCollapsed (row) {
			let rowData = row.getData()
			rowData._children = []
		},
		onMultiSelect (e) {
			e.stopImmediatePropagation()
			if (!this.multiselect) return
			let selectedRows = this.table.getSelectedRows()
			if (selectedRows.length > 0) {
				for (let i = 0; i < selectedRows.length; i++) {
					this.table.deselectRow(selectedRows[i])
				}
			} else {
				let rows = this.table.getRows()
				this.setAllSelectRecusive(rows)
			}
			this.updateMultiSelectorHtml()
		},
		onRowSelection (row) {
			row.reformat()
			this.updateMultiSelectorHtml()
		},
		onRowSelectionChanged (data, rows) {
			this.selected = data
			this.selected_rows = rows
		},
		buildTable () {
			let selectable = this.multiselect ? true : 1
			let container = document.getElementById('explorer-table-top')
			let topOffset = 0
			// console.log(container.getBoundingClientRect().top);
			if (container) topOffset = container.getBoundingClientRect().top || 242
			topOffset += 50
			let that = this
			let table = new Tabulator('#explorer-table', {
				maxHeight: `calc(100vh - ${topOffset}px)`,
				data: [],
				index: 'path',
				initialSort: [
					{column: 'name', dir: 'asc'}
				],
				placeholder: '-- vide --',
				reactiveData: true,
				layout: 'fitColumns',
				resizableColumns: false,
				selectable: selectable,
				cellVertAlign: 'middle',
				columns: [
					{
						title: 'Nom',
						field: 'name',
						cssClass: 'path-cell',
						formatter: formatters.pathFormater,
						cellClick: (e, cell) => {
							e.preventDefault()
							e.stopPropagation()
							let row = cell.getRow()
							let rowData = row.getData()
							if ((e.ctrlKey || e.metaKey) && rowData.type === 'folder') {
								this.onCurrentPathChange(rowData.path)
							} else if (rowData.isSelectable) {
								row.toggleSelect()
							}
						},
						cellDblClick: (e, cell) => {
							e.preventDefault()
							e.stopPropagation()
							let row = cell.getRow()
							let rowData = row.getData()
							if (rowData.type === 'folder') {
								row.treeToggle()
							}
						}
					},
					{
						title: 'Poids',
						field: 'size',
						width: 100,
						hozAlign: 'right',
						formatter: formatters.weight1024Formatter
					},
					{
						title: 'Modification',
						field: 'mod_date',
						width: 112,
						hozAlign: 'center',
						formatter: formatters.dateFormatter
					},
					{
						title: '',
						field: 'copy',
						width: 40,
						tooltip: 'Copier le chemin',
						headerSort: false,
						hozAlign: 'center',
						formatter: (cell) => formatters.cellButton(cell, 'copy'),
						cellClick: (e, cell) => {
							e.stopPropagation()
							let path = cell.getRow().getData().path
							this.copyPath(path)
						}
					}
				],
				dataTree: true,
				dataTreeFilter: false,
				dataTreeChildIndent: 14,
				dataTreeExpandElement: formatters.treeExpander,
				dataTreeCollapseElement: formatters.treeCollapser,
				dataTreeRowExpanded: this.onDataTreeRowExpanded,
				dataTreeRowCollapsed: this.onDataTreeRowCollapsed,
				selectableCheck: (row) => {
					return row.getData().isSelectable
				},
				rowSelected: this.onRowSelection,
				rowDeselected: this.onRowSelection,
				rowSelectionChanged: this.onRowSelectionChanged,
				rowContextMenu: (component, evt) => {
					let rowData = component.getData()
					if (!rowData) return
					if (['file', 'folder', 'empty'].indexOf(rowData.type) === -1) return
					let items = []
					if (rowData.isSelectable) {
						let type = component.isSelected() ? 'unselect' : 'select'
						items.push({
							label: formatters.menuItem(type),
							action: (e, column) => {
								component.toggleSelect()
							}
						})
					}

					if (['file', 'folder'].indexOf(rowData.type) > -1) {
						if (this.launcher) {
							let type = rowData.type
							if (type === 'folder') type = 'directory'
							items.push({
								label: formatters.menuItem('launcher'),
								action: (e, column) => {
									this.$emit('show-launcher', {
										type: [ type, 'path' ],
										value: rowData.path // Déjà en format Maestro
									})
								}
							})
						}

						items.push({
							label: formatters.menuItem('copy'),
							action: (e, column) => {
								this.copyPath(rowData.path)
							}
						})

						items.push({
							label: formatters.menuItem('open'),
							action: (e, column) => {
								if (rowData.type === 'file') {
									this.openFile('show', rowData.path)
								} else if (rowData.type === 'folder') {
									this.openFile('open', rowData.path)
								}
							}
						})

						if (rowData.type === 'file') {
							items.push({
								label: formatters.menuItem('probe'),
								action: (e, column) => {
									this.probeFile(rowData.path)
								}
							})

							// Current file is a picture
							if (that.image_extensions.some(ext => {
								return rowData.ext.substring(1).toLowerCase() === ext.toLowerCase()
							})) {
								// Start building image viewer before user clicks on "Visualiser"
								let rows = component.getTreeParent() ? component.getTreeParent().getTreeChildren() : that.table.getRows()
								let container = document.createElement('div')
								let promises = []
								rows.forEach(r => {
									let data = r.getData()
									if (that.image_extensions.some(ext => {
										return data.ext.substring(1).toLowerCase() === ext.toLowerCase()
									})) {
										promises.push(new Promise((resolve, reject) => {
											let img = new Image()
											img.src = this.$ApiNexus.download_url(data.path)
											console.log('Loading image for path:', data.path, img.src)
											img.title = data.name
											img.addEventListener('load', function () {
												container.append(img)
												resolve()
											})
											img.addEventListener('error', function () {
												console.error('Error loading image "' + data.path + '"')
												resolve()
											})
										}))
									}
								})

								items.push({
									label: formatters.menuItem('view_image'),
									action: (e, column) => {
										that.loading = true
										// Wait for image loading before showing image viewer
										Promise.all(promises).then(() => {
											that.loading = false
											// Sort images
											let img_list = Array.from(container.children)
											img_list.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()))
											// Find selected image
											let selected_index = img_list.findIndex(i => i.title === rowData.name)
											// Put back sorted images into HTML
											container.innerHTML = ''
											img_list.forEach(img => container.appendChild(img))
											// Build Viewer
											that.build_image_viewer(container, selected_index)
										})
									}
								})
							} else {
								// "Read" option for HTML files
								if (rowData.ext.substring(1).toLowerCase() === 'html') {
									items.push({
										label: formatters.menuItem('view_html'),
										action: (e, column) => {
											this.html_to_read = rowData.path
										}
									})
								} else {
									// "Read" option for other file formats
									items.push({
										label: formatters.menuItem('read'),
										action: (e, column) => {
											this.file_to_read = rowData.path
										}
									})
								}
							}

							items.push({
								label: formatters.menuItem('favorite'),
								action: (e, column) => {
									this.addUserFavorite(rowData.path.substring(
										0,
										rowData.path.lastIndexOf('/')
									))
								}
							})
						} else if (rowData.type === 'folder') {
							items.push({
								label: formatters.menuItem('navigate', rowData.path),
								action: (e, column) => {
									if (rowData._children.length > 0) {
										if (rowData._children.length === 1 && rowData._children[0].type === 'empty') {
											this.onCurrentPathChange(rowData.path)
										} else {
											this.updateUrl(rowData.path)
											this.current_path = rowData.path
											if (this.table) this.table.setData(rowData._children)
											this.items = rowData._children
										}
									} else {
										this.onCurrentPathChange(rowData.path)
									}
								}
							})

							items.push({
								label: formatters.menuItem('list'),
								action: (e, column) => {
									this.list_dir_dialog.root_path = rowData.path
									this.list_dir_dialog.deep = false
								}
							})

							items.push({
								label: formatters.menuItem('list_full'),
								action: (e, column) => {
									this.list_dir_dialog.root_path = rowData.path
									this.list_dir_dialog.deep = true
								}
							})

							items.push({
								label: formatters.menuItem('favorite'),
								action: (e, column) => {
									this.addUserFavorite(rowData.path)
								}
							})
						}
					}

					let destFolderPath = null
					if (['folder', 'empty'].indexOf(rowData.type) > -1) {
						destFolderPath = rowData.path + '/'
					} else if (rowData.type === 'file') {
						destFolderPath = rowData.path.substring(
							0,
							rowData.path.lastIndexOf('/')
						) + '/'
					}
					if (destFolderPath) {
						if (isUploaderEnabled(destFolderPath, this.error_nav)) {
							items.push({
								label: formatters.menuItem('mkdir'),
								action: (e, column) => {
									this.mkdir_dialog.dest_path = destFolderPath
									let destPathLabel = destFolderPath
									if (destPathLabel.length > 30) {
										destPathLabel = destFolderPath.substring(0, 15)
										destPathLabel += '...'
										destPathLabel += destFolderPath.substring(
											destFolderPath.length - 15
										)
									}
									this.mkdir_dialog.dest_path_label = destPathLabel
									this.mkdir_dialog.show = true
								}
							})
						}
					}

					let titleIcon = 'insert_drive_file'
					if (['folder', 'empty'].indexOf(rowData.type) > -1) {
						titleIcon = 'folder'
					}
					this.context_menu.x = evt.clientX
					this.context_menu.y = evt.clientY
					this.context_menu.title.text = rowData.name
					this.context_menu.title.icon = titleIcon
					this.context_menu.items = items
					this.context_menu.show = true

					if (rowData.type !== 'empty') {
						this.context_menu.items.push({
							label: {
								...formatters.menuItem('asset_id'),
								loading: true
							},
							action: () => {}
						})

						this.$EsMaestro.asset_from_filepath(rowData.path)
							.then(asset => {
								this.$set(
									this.context_menu.items,
									this.context_menu.items.length - 1,
									{
										label: formatters.menuItem('asset_id', asset.id),
										action: (e, column) => {
											this.$Bus.$emit('show-asset-modal', {
												asset: asset,
												tab: 'locations'
											})
										}
									}
								)
							})
							.catch(() => {
								this.context_menu.items.splice(
									this.context_menu.items.length - 1,
									1
								)
							})
					}
				}
			})
			if (selectable) {
				table.addColumn({
					field: 'selector',
					width: 40,
					headerHozAlign: 'center',
					hozAlign: 'center',
					cssClass: 'select-cell',
					titleFormatter: () => {
						return formatters.headerSelector(false, this.multiselect)
					},
					formatter: formatters.selector,
					vertAlign: 'middle',
					headerSort: false,
					headerClick: this.onMultiSelect
				})
					.then(() => {
						table.moveColumn('selector', 'name', false)
					})
					.catch(error => {
						console.error(error)
					})
			}
			if (this.$OS === 'Windows') {
				if (this.$store.getters.fileopener_status) {
					table.addColumn({
						title: '',
						field: 'open',
						width: 40,
						tooltip: 'Ouvrir avec Fileopener',
						headerSort: false,
						hozAlign: 'center',
						formatter: (cell) => formatters.cellButton(cell, 'open'),
						cellClick: (e, cell) => {
							e.stopPropagation()
							let rowData = cell.getRow().getData()
							if (rowData.type === 'file') {
								this.openFile('show', rowData.path)
							} else if (rowData.type === 'folder') {
								this.openFile('open', rowData.path)
							}
						}
					})
						.catch(error => {
							console.error(error)
						})
				}
				table.addColumn({
					title: '',
					field: 'path',
					width: 40,
					tooltip: 'Lire avec Switch',
					headerSort: false,
					hozAlign: 'center',
					formatter: (cell) => formatters.cellButton(cell, 'play'),
					cellClick: (e, cell) => {
						e.stopPropagation()
						this.$Bus.$emit('switch_player', cell.getValue())
					}
				})
					.catch(error => {
						console.error(error)
					})
			}
			this.table = table
		},
		updateMultiSelectorHtml () {
			let el = document.getElementById('multi-selector')
			if (!el) return
			let icon = 'check_box_outline_blank'
			let color = ''
			let selectedCount = this.table.getSelectedData().length
			if (selectedCount > 0) {
				color = 'primary--text'
				let selectableCount = this.getSelectableCountRecusive(
					this.table.getData()
				)
				if (selectableCount === selectedCount) {
					icon = 'check_box'
				} else {
					icon = 'indeterminate_check_box'
				}
			}
			el.innerHTML = `
				<i style="font-size: 24px" class="v-icon material-icons ${color}">
					${icon}
				</i>
			`
		},
		getCurrentSelectedFileListRecursive (selectedPath, list, limiter) {
			if (limiter > 99) return []
			limiter++
			for (let i = 0; i < list.length; i++) {
				if (list[i].path === selectedPath) {
					return list.map(item => item.path)
				}
				if (list[i]._children && selectedPath.indexOf(list[i].path) === 0) {
					return this.getCurrentSelectedFileListRecursive(
						selectedPath,
						list[i]._children,
						limiter
					)
				}
			}
			return []
		},
		getSelectableCountRecusive (items) {
			let count = 0
			for (let i = 0; i < items.length; i++) {
				if (items[i].isSelectable) count++
				if (items[i]._children) {
					if (items[i]._children.length > 0) {
						count += this.getSelectableCountRecusive(items[i]._children)
					}
				}
			}
			return count
		},
		setAllSelectRecusive (items) {
			for (let i = 0; i < items.length; i++) {
				let itemData = items[i].getData()
				if (itemData.isSelectable) this.table.selectRow(items[i])
				let rowChildren = items[i].getTreeChildren()
				if (rowChildren.length > 0) this.setAllSelectRecusive(rowChildren)
			}
		},
		setAllChildLoadedRowsExpandedRecusive (rows) {
			rows.map(row => {
				let rowChildren = row.getTreeChildren()
				if (rowChildren.length > 0) {
					row.treeExpand()
					this.setAllChildLoadedRowsExpandedRecusive(rowChildren)
				}
			})
		},
		getFilteredRecursive (items, search) {
			return items.filter(function f (o) {
				if (o.name.toLowerCase().indexOf(search) > -1) return true
				if (o._children) return (o._children = o._children.filter(f)).length
			})
		},
		emitSelected (selected) {
			if (this.multiselect) {
				this.$emit('asset-selected', selected)
			} else {
				if (!this.return_dir_filelist) {
					this.$emit('asset-selected', selected[0])
				} else {
					this.$emit('asset-selected', {
						selected: selected[0],
						filelist: this.getCurrentSelectedFileListRecursive(
							selected[0].path,
							this.table.getData(),
							0
						)
					})
				}
			}
			let selectedPath = selected[0].path
			if (selected[0].type === 'file') {
				selectedPath = selectedPath.substring(0, selectedPath.lastIndexOf('/'))
			}
			this.addUserHistory(selectedPath)
			this.prevent_store_path = true
		},
		directDDL (selected_items) {
			// CHeck no item is selected inside a selected folder
			let folders = selected_items.filter(item => item.type === 'folder').map(item => item.path)
			for (const selected_item of selected_items) {
				if (folders.some(folder => {
					return selected_item.path.indexOf(folder) === 0 && selected_item.path !== folder
				})) {
					this.$Toaster({
						title: `Attention`,
						content: 'Veuillez ne pas sélectionner un dossier et un de ses sous éléments en même temps',
						type: 'warning',
						loading: false,
						timeout: 0
					})
					return
				}
			}
			this.$Bus.$emit('launcher', {
				jd_id: window.appConfig.maestro_wf['Direct DDL'].id,
				direct_edit: true,
				parameters: {
					sources: selected_items.map(item => {
						return item.path // Déjà en format Maestro
					})
				}
			})
		},
		handleKeyDown (keyDownEvent) {
			if ((keyDownEvent.ctrlKey || keyDownEvent.metaKey) && !keyDownEvent.shiftKey && keyDownEvent.key === 'ArrowLeft') {
				keyDownEvent.preventDefault()
				this.navigateBack()
			} else if ((keyDownEvent.ctrlKey || keyDownEvent.metaKey) && keyDownEvent.key === 'ArrowUp') {
				keyDownEvent.preventDefault()
				this.navigateRoot()
			} else if (keyDownEvent.altKey && (keyDownEvent.key === 'f' || keyDownEvent.key === 'ƒ')) {
				keyDownEvent.preventDefault()
				this.$refs.search_input.focus()
			}
		},
		emitSupportPayload () {
			let payload = {
				file_explorer: {
					shortcuts_count: this.shortcuts_list.length,
					items_count: this.items.length
				}
			}
			if (this.assetType) {
				payload.file_explorer.asset_type = this.assetType
			}
			if (this.multi_select) {
				payload.file_explorer.multi_select = this.multi_select
			}
			if (this.default_folder) {
				payload.file_explorer.default_folder = this.default_folder
			}
			if (this.selected_shortcut) {
				payload.file_explorer.selected_shortcut = this.selected_shortcut
			}
			if (this.search) {
				payload.file_explorer.search = this.search
			}
			if (this.current_path) {
				payload.file_explorer.current_path = this.current_path
			}
			if (this.error_nav) {
				payload.file_explorer.error_nav = this.error_nav
			}
			if (this.selected_count) {
				payload.file_explorer.selected_count = this.selected_count
			}
			this.$Bus.$emit('set_support_payload', payload)
		},
		build_image_viewer (container, selected_index) {
			// No image to view
			if (container.children.length === 0) return

			this.image_container = container
			let that = this

			// Build viewer
			this.image_viewer = new Viewer(container, {
				hidden: () => {
					that.closeImageViewer()
				},
				toolbar: {
					zoomIn: 4,
					zoomOut: 4,
					oneToOne: 4,
					reset: 4,
					prev: 4,
					play: {
						show: 4,
						size: 'large'
					},
					next: 4,
					rotateLeft: 0,
					rotateRight: 0,
					flipHorizontal: 0,
					flipVertical: 0
				}
			})

			// Select clicked image
			if (selected_index > -1 && selected_index < container.children.length) {
				container.children[selected_index].click()
			}

			// Display viewer
			this.image_viewer.show()
		},
		closeImageViewer () {
			if (this.image_viewer) {
				this.image_viewer.destroy()
				this.image_viewer = null
			}
			if (this.image_container) {
				this.image_container.remove()
				this.image_container = null
			}
		},
		// Migration silencieuse des chemins UNC vers Maestro dans localStorage
		migrateLocalStoragePaths () {
			const migrateArray = (key) => {
				let data = window.localStorage.getItem(key)
				if (!data) return
				try {
					let parsed = JSON.parse(data)
					let needsMigration = parsed.some(path => path && path.startsWith('//'))
					if (needsMigration) {
						let migrated = parsed.map(path => {
							if (path && path.startsWith('//')) {
								return this.$paths.UNCToMaestro(path)
							}
							return path
						})
						window.localStorage.setItem(key, JSON.stringify(migrated))
					}
				} catch (e) {
					console.error('Migration error for ' + key, e)
				}
			}
			migrateArray('fs_favorites')
			migrateArray('fs_history')
		}
	},
	beforeMount () {
		this.migrateLocalStoragePaths()
		if (!this.shortcuts) this.pdm_list = this.$Pdms
		if (this.default_folder) {
			this.onCurrentPathChange(this.default_folder)
		} else if (this.$route.name === 'Filesystem' && this.$route.query.path) {
			this.onCurrentPathChange(this.$route.query.path)
		} else {
			this.getUserHistory()
			if (this.user_history.length > 0 && !this.no_previous_path) {
				this.onCurrentPathChange(
					this.user_history[this.user_history.length - 1]
				)
			}
		}
	},
	mounted () {
		this.getUserFavorites()
		this.getUserHistory()
		this.buildTable()
		document.addEventListener('keydown', this.handleKeyDown)
		this.$Bus.$on('get_support_payload', this.emitSupportPayload)
		let emptyTableEl = document.getElementsByClassName('tabulator-placeholder')
		if (emptyTableEl) {
			if (emptyTableEl[0]) {
				emptyTableEl[0].addEventListener('contextmenu', (evt) => {
					evt.preventDefault()
					let items = []
					let destPath = this.current_path + '/'
					let destFolderName = this.current_path.substring(
						this.current_path.lastIndexOf('/')
					)
					if (destPath) {
						if (isUploaderEnabled(destPath, this.error_nav)) {
							items.push({
								label: formatters.menuItem('mkdir'),
								action: (e, column) => {
									this.mkdir_dialog.dest_path = destPath
									let destPathLabel = destPath
									if (destPathLabel.length > 30) {
										destPathLabel = destPath.substring(0, 15)
										destPathLabel += '...'
										destPathLabel += destPath.substring(destPath.length - 15)
									}
									this.mkdir_dialog.dest_path_label = destPathLabel
									this.mkdir_dialog.show = true
								}
							})
							this.context_menu.x = evt.clientX
							this.context_menu.y = evt.clientY
							this.context_menu.title.text = destFolderName
							this.context_menu.title.icon = 'folder'
							this.context_menu.items = items
							this.context_menu.show = true
						}
					}
				})
			}
		}
	},
	destroyed () {
		this.$Bus.$off('get_support_payload', this.emitSupportPayload)
		document.removeEventListener('keydown', this.handleKeyDown)
		if (this.current_path && !this.prevent_store_path && !this.loading) {
			this.addUserHistory(this.current_path)
		}
	}
}
</script>

<style lang="stylus" scoped>
.tabulator
	border: none
	background-color: transparent
	max-width: 100%
	>>>.tabulator-tableHolder
		overflow-x: hidden
		background-color: var(--v-background-darken1)
		border: 1px solid var(--v-background-lighten1)
	>>>.tabulator-header
		border: none
		border-left: 1px solid var(--v-background-lighten1)
		border-right: 1px solid var(--v-background-lighten1)
		background-color: var(--v-background-darken1)
		.tabulator-col
			border-right: none
			background-color: var(--v-background-darken1)
			height: 32px
			min-height: 32px
			max-height: 32px
			&:hover
				color: var(--v-primary-base) !important
				background-color: #84FFFF22
		.tabulator-col.select-cell
			cursor: pointer
			&:hover
				.v-icon
					color: var(--v-primary-base) !important
	>>>.tabulator-col-title
		font-weight: normal
	>>>.path-cell
		.tabulator-col-title
			padding-left: 18px !important
	>>>.tabulator-col:not(.path-cell)
		.tabulator-col-title
			text-align: center
	>>>.tabulator-table
		background-color: var(--v-background-darken1) !important
		.tabulator-row-odd
			background-color: rgba(255, 255, 255, 0.05) !important
		.tabulator-row-even
			background-color: rgba(255, 255, 255, 0.1) !important
		.tabulator-row
			height: 32px
			min-height: 32px
			max-height: 32px
			.tabulator-cell
				cursor: pointer
				border-right: none
				.tabulator-data-tree-branch
					border-color: white
			.tabulator-cell:not(.path-cell):hover
				.v-icon
					color: var(--v-primary-base) !important
			.v-icon.expander:hover
				color: var(--v-primary-base) !important
		.tabulator-row:hover
			background-color: #84FFFF33
			// .tabulator-cell
			// 	background-color: var(--v-background-darken1)
	>>>.tabulator-unselectable
		.path-cell
			opacity: 0.7

>>>.tabulator-tree-level-0
	.path-cell
		padding-left: 4px !important
>>>.tabulator-tree-level-1
	.path-cell
		padding-left: 18px !important
>>>.tabulator-tree-level-2
	.path-cell
		padding-left: 32px !important
>>>.tabulator-tree-level-3
	.path-cell
		padding-left: 46px !important
>>>.tabulator-tree-level-4
	.path-cell
		padding-left: 60px !important
>>>.tabulator-tree-level-5
	.path-cell
		padding-left: 74px !important
>>>.tabulator-tree-level-6
	.path-cell
		padding-left: 88px !important
>>>.tabulator-tree-level-7
	.path-cell
		padding-left: 102px !important
>>>.tabulator-tree-level-8
	.path-cell
		padding-left: 116px !important
>>>.tabulator-tree-level-9
	.path-cell
		padding-left: 130px !important
>>>.tabulator-tree-level-10
	.path-cell
		padding-left: 144px !important
>>>.tabulator-tree-level-11
	.path-cell
		padding-left: 158px !important
>>>.tabulator-tree-level-12
	.path-cell
		padding-left: 172px !important

.path-btn
	margin: 0 2px
	padding: 0 4px
	min-width: inherit
	font-size: 16px
	outline: 1px solid var(--v-background-lighten1)
	border-radius: 4px
	height: 22px
	&.v-btn--disabled
		color: inherit !important
		opacity: 0.6
		.v-icon
			color: inherit !important
			opacity: 0.6
	&:not(.v-btn--disabled):hover
		padding: 4px 8px
		height: 26px
		color: var(--v-primary-base)

.path-breadcrumb
	background-color: var(--v-background-darken1) !important
	border: 1px solid var(--v-background-lighten1) !important
	border-top-left-radius: 8px
	border-top-right-radius: 8px
.table-footer
	background-color: var(--v-background-darken1) !important
	border-left: 1px solid var(--v-background-lighten1) !important
	border-right: 1px solid var(--v-background-lighten1) !important
	border-bottom: 1px solid var(--v-background-lighten1) !important
	height: 50px

.grv-input
	>>>.v-input__control
		margin-bottom: 4px !important
	>>>.v-input__slot
		box-shadow: none !important
		background-color: var(--v-background-darken1) !important
		.v-label
			top: -28px !important

.pdms-input
	>>>.v-input__slot
		border-top-left-radius: 8px
		border-bottom-left-radius: 8px
	>>>.v-label
		left: -10px !important

.path-input
	>>>.v-input__slot
		padding-left: 4px
		border-top-right-radius: 8px
		border-bottom-right-radius: 8px
	>>>.v-label
		left: -42px !important

.search-input
	max-width: 106px
	transition: max-width 0.2s
	&.v-input--is-focused
	&.v-input--is-dirty
	&:hover
		max-width: 400px !important
	>>>.v-label
		left: -10px !important
		max-width: none !important
	>>>.v-input__control
		margin: 0 !important
</style>



// WEBPACK FOOTER //
// src/pages/filesystem/explorer.vue